import { render } from "./BkashPayment.vue?vue&type=template&id=0ac96628"
import script from "./BkashPayment.vue?vue&type=script&lang=js"
export * from "./BkashPayment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hutch/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__